import { RouterPath } from '@src/constants/router_path';

/**
 * プレビューを非表示にするルート一覧。
 * 同時にルート遷移時に保存対象外とするための共通セットとしても利用する。
 */
const PREVIEW_HIDDEN_ROUTE_SET: ReadonlySet<string> = new Set<string>([
  RouterPath.index,
  RouterPath.faq,
  RouterPath.selectMode,
  RouterPath.login,
  RouterPath.register,
  RouterPath.mfaVerify,
  RouterPath.passwordResetRequest,
  RouterPath.passwordResetConfirm,
  RouterPath.profile,
  RouterPath.exportImport,
]);

/**
 * プレビューを表示すべきかのヘルパー。
 */
export const isPreviewRoute = (path: string): boolean => !PREVIEW_HIDDEN_ROUTE_SET.has(path);

/**
 * ルートを永続化対象とするかどうかのヘルパー。
 * 今のところプレビュー表示非対応ルートと同じ条件だが、将来の拡張に備えて分離。
 */
export const shouldPersistRouteState = (path: string): boolean => isPreviewRoute(path);
